import { createCRUDHook } from './createCRUDHook';
import { StoreSectionPartOrAssemblyDto } from 'utils/models';
import {
  CREATE_BULK_ENTITY,
  ECG_STORE_SECTION_PART_OR_ASSEMBLY,
} from './apiEndPoints';

interface StoreSectionPartOrAssemblyCustomOperations {
  addBulkStoreSectionPartOrAssemblyData: (
    param: StoreSectionPartOrAssemblyDto[]
  ) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  StoreSectionPartOrAssemblyDto,
  StoreSectionPartOrAssemblyDto[],
  StoreSectionPartOrAssemblyCustomOperations
>({
  entityName: 'StoreSectionPartOrAssembly',
  endpoint: ECG_STORE_SECTION_PART_OR_ASSEMBLY,

  customOperations: (auth) => ({
    addBulkStoreSectionPartOrAssemblyData: async (
      param: StoreSectionPartOrAssemblyDto[]
    ): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          ECG_STORE_SECTION_PART_OR_ASSEMBLY + CREATE_BULK_ENTITY,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const StoreSectionPartOrAssemblyContext = Context;
export const useStoreSectionPartOrAssemblyManager = useManager;
export const useStoreSectionPartOrAssembly = useConsumer;
